import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { IoIosArrowBack } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { playSong } from '../../common/actions/common.actions';
import { selectLoginData } from "../login/login.actions";
import transactionService from '../../../api/services/transactionService';
import Modal from '../../common/components/modal';
import Deposite from './deposite';
import Withdrawal from './withdrawal';

const Transactions = ({ setIsLoading }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [message, setMessage] = useState(t('processSuccessful'));
  const [accountList, setAccountList] = useState([]);
  const [activeTab, setActiveTab] = useState('deposite');
  const [balance, setBalance] = useState(0);

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));

  useEffect(() => {
    fetchAccountList();
  }, []);

  const fetchAccountList = async () => {
    try {
      setIsLoading(true);
      const response = await transactionService.getPaymentAccountList(Number(userDetails.userId));
      const data = await response.json();

      if (data) {
        setAccountList(data.payload);
        setBalance(data.balance);
      }
    } catch (error) {
      console.error("API request error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleSongClick = async () => {
    dispatch(playSong());
  };

  const handleClick = () => {
    handleSongClick();
    navigate('/dashboard');
  };

  return (
    <div className="flex flex-col w-full min-h-screen bg-gradient-to-br from-[#EAEAEA] via-green-50 to-[#228B22]/10 relative font-dangrek">

      {/* Header */}
      <div className="relative z-10 bg-gradient-to-r from-[#228B22] via-emerald-600 to-[#1F5F1F] py-4 px-4 shadow-sm">
        <div className="flex items-center">
          <button
            className="w-10 h-10 mr-4 flex justify-center items-center text-white rounded-xl active:bg-white/20"
            onClick={handleClick}
          >
            <IoIosArrowBack size={25} />
          </button>
          <div>
            <h3 className="text-white font-bold text-xl">{t("transaction")}</h3>
            <p className="text-emerald-100 text-xs font-medium">Deposit & Withdraw</p>
          </div>
        </div>
      </div>

      {/* Tab Buttons */}
      <div className="relative z-10 mt-4 mb-4 px-4">
        <div className="bg-white/80 rounded-2xl p-3 border border-[#228B22]/20 shadow-sm">
          <div className="flex gap-2">
            <button
              onClick={() => setActiveTab('deposite')}
              className={`flex-1 py-3 rounded-xl font-bold text-sm ${
                activeTab === 'deposite'
                  ? 'bg-gradient-to-r from-[#228B22] to-emerald-600 text-white shadow-sm'
                  : 'bg-white text-[#228B22] border border-[#228B22]/20'
              }`}
            >
              <div className="flex items-center justify-center">
                <span className="w-2 h-2 bg-[#FFD700] rounded-full mr-2"></span>
                {t("deposite")}
              </div>
            </button>
            <button
              onClick={() => setActiveTab('withdraw')}
              className={`flex-1 py-3 rounded-xl font-bold text-sm ${
                activeTab === 'withdraw'
                  ? 'bg-gradient-to-r from-[#228B22] to-emerald-600 text-white shadow-sm'
                  : 'bg-white text-[#228B22] border border-[#228B22]/20'
              }`}
            >
              <div className="flex items-center justify-center">
                <span className="w-2 h-2 bg-[#1E90FF] rounded-full mr-2"></span>
                {t("withdraw")}
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="relative z-10 flex-1 px-4 pb-4">
        <div className="bg-white/80 rounded-2xl p-6 border border-[#228B22]/20 shadow-sm">
          {activeTab === "deposite" ? (
            <Deposite
              accountList={accountList}
              t={t}
              userDetails={userDetails}
              setIsLoading={setIsLoading}
              setIsModalOpen={setIsModalOpen}
              setMessage={setMessage}
              handleSongClick={handleSongClick}
            />
          ) : (
            <Withdrawal
              accountList={accountList}
              t={t}
              userDetails={userDetails}
              balance={balance}
              fetchAccountList={fetchAccountList}
              setIsLoading={setIsLoading}
              setIsModalOpen={setIsModalOpen}
              setMessage={setMessage}
              handleSongClick={handleSongClick}
            />
          )}
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <Modal title="777 Soccer" content={message} onClose={closeModal} />
      )}
    </div>
  );
};

export default Transactions;
